export default "__VITE_ASSET__DzNWuMwE__"